import { PersonForm } from '~domains/profile/widgets/person-form';
import { ProfileFormNavigationConnected } from '~domains/profile/widgets/profile-form-navigation';

export const ProfilePage = () => {
  return <PersonForm navigation={<ProfileFormNavigationConnected />} />;
};
